export default __webpack_public_path__ + "static/media/x-twitter-white.8342e481.svg";